// @ts-expect-error TS7016
import GoogleMapReact from 'google-map-react'

import { Box } from '@domain-group/suit-theme'

import { UseGeocodePayload } from '@hooks/useGeocode'

import MapMarker from '../MapMarker'

interface MapProps {
  useGeocodePayload: UseGeocodePayload,
}

const Map = (props: MapProps) => {
  const { useGeocodePayload: { editing, latitude, longitude } } = props

  return (
    <Box height="200px" marginTop={editing ? 'large' : 0}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_PLACES_API_KEY }}
        key={Number(latitude) || 1}
        options={{ gestureHandling: 'none' }}
        defaultCenter={{
          lat: Number(latitude) || -33.762390,
          lng: Number(longitude) || 151.271271,
        }}
        defaultZoom={17}
      >
        <MapMarker
          // @ts-expect-error TS2322
          lat={Number(latitude)}
          lng={longitude}
        />
      </GoogleMapReact>
    </Box>
  )
}

export default Map
